import { v4 as uuidv4 } from "uuid";
import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";

const cloneSingleBlock = (block: BaseBlock): BaseBlock =>
  JSON.parse(JSON.stringify(block), (key: string, value: unknown): unknown => {
    if (key === "id" && typeof value === "string") {
      return uuidv4();
    }
    return value;
  }) as BaseBlock;

export function cloneWithNewIDs(block: BaseBlock): BaseBlock;
export function cloneWithNewIDs(block: BaseBlock[]): BaseBlock[];
export function cloneWithNewIDs(
  block: BaseBlock | BaseBlock[],
): BaseBlock | BaseBlock[] {
  if (Array.isArray(block)) {
    return block.map(b => {
      if (Array.isArray(b)) {
        throw new Error("Nested arrays are not supported in BaseBlock");
      }
      return cloneSingleBlock(b);
    });
  }

  return cloneSingleBlock(block);
}
